import { render, staticRenderFns } from "./VideoLayer.vue?vue&type=template&id=5a9c4bc4&"
import script from "./VideoLayer.vue?vue&type=script&lang=ts&"
export * from "./VideoLayer.vue?vue&type=script&lang=ts&"
import style0 from "./VideoLayer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports